import HubspotConnector from "./HubspotConnector";

export default HubspotConnector;
